const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Crear nuevo alistamiento
 */
export const createAlistamiento = async (alistamientoData) => {
  try {
    const response = await fetch(`${API_URL}/alistamientos/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(alistamientoData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al crear el alistamiento');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al crear alistamiento:', error);
    throw error;
  }
};

/**
 * Obtener alistamientos con filtros
 */
export const getAlistamientos = async (filters = {}) => {
  try {
    const { query = {}, page = 1, limit = 10 } = filters;
    
    const response = await fetch(`${API_URL}/alistamientos/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        page,
        limit,
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los alistamientos');
    }

    const result = await response.json();
    
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error al obtener alistamientos:', error);
    throw error;
  }
};

/**
 * Obtener alistamiento por ID
 */
export const getAlistamientoById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/alistamientos/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener el alistamiento');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener alistamiento:', error);
    throw error;
  }
};

/**
 * Obtener alistamientos por cliente
 */
export const getAlistamientosByCliente = async (clienteId) => {
  try {
    const response = await fetch(`${API_URL}/alistamientos/cliente/${clienteId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener alistamientos del cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener alistamientos del cliente:', error);
    throw error;
  }
};

/**
 * Obtener alistamientos por lavandería con paginación y filtros
 */
export const getAlistamientosByLavanderia = async (lavanderiaId, filters = {}) => {
  try {
    const { query = {}, page = 1, limit = 20 } = filters;
    
    // Agregar lavanderiaId al query
    const fullQuery = { ...query, lavanderiaId };
    
    const response = await fetch(`${API_URL}/alistamientos/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: fullQuery,
        page,
        limit,
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener alistamientos de la lavandería');
    }

    const result = await response.json();
    
    return {
      data: result.data || [],
      totalRecords: result.totalRecords || 0,
      totalPages: result.totalPages || 0,
      currentPage: result.currentPage || page,
    };
  } catch (error) {
    console.error('Error al obtener alistamientos de la lavandería:', error);
    throw error;
  }
};

/**
 * Eliminar alistamiento
 */
export const deleteAlistamiento = async (id) => {
  try {
    const response = await fetch(`${API_URL}/alistamientos/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al eliminar el alistamiento');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al eliminar alistamiento:', error);
    throw error;
  }
};

/**
 * Poner múltiples alistamientos en ruta (genera un solo registro de entrega consolidado)
 */
export const marcarLoteComoEntregado = async (alistamientoIds, conductor, tipoEntrega, observacionEntrega) => {
  try {
    const response = await fetch(`${API_URL}/alistamientos/entregar-lote`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ alistamientoIds, conductor, tipoEntrega, observacionEntrega }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al poner alistamientos en ruta');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al poner lote en ruta:', error);
    throw error;
  }
};

/**
 * Marcar alistamiento como entregado con conductor
 */
export const marcarComoEntregado = async (id, conductor, observacionEntrega) => {
  try {
    const response = await fetch(`${API_URL}/alistamientos/entregar/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        conductor,
        observacionEntrega,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al marcar el alistamiento como entregado');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al marcar alistamiento como entregado:', error);
    throw error;
  }
};
